import { render, staticRenderFns } from "./FolderPicker.vue?vue&type=template&id=ff4415d8&scoped=true"
import script from "./FolderPicker.vue?vue&type=script&lang=js"
export * from "./FolderPicker.vue?vue&type=script&lang=js"
import style0 from "./FolderPicker.vue?vue&type=style&index=0&id=ff4415d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4415d8",
  null
  
)

export default component.exports